export default __webpack_public_path__ + "static/media/middleRenderMusuem.f7fbd541.webp";